import {loadLang, addMessages} from '@/base/locales'

const modules = import.meta.glob('./lang/*/*.ts', { eager: true });
const messages = loadLang(modules)

addMessages(messages)